var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('table-items',{attrs:{"active-table-field":_vm.tableItemsActiveField,"items":_vm.items,"restoreState":false}}),_c('div',{staticClass:"row text-center pt-3"},[_c('div',{staticClass:"mt-3 ml-auto mr-auto color"},[_c('pagination',{attrs:{"meta":_vm.paginationMeta,"on-change-page":_vm.changePage}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }